import Ru from './Ru';
import En from './En';

export default {
  Ru,
  En,
};
